module.exports = __webpack_public_path__ + "static/media/2-BiometriaDactilarMadit.c456aef1.jpg";